export const EMAIL_REGEX = /^[^\s@]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;

export const PLACEHOLDER_AVATAR_BASE_URL = 'https://thispersondoesnotexist.com/random-person.jpeg';

export function placeholderAvatarUrl(seed?: string | null): string {
  if (!seed)
    return PLACEHOLDER_AVATAR_BASE_URL;

  return `${PLACEHOLDER_AVATAR_BASE_URL}?u=${encodeURIComponent(seed)}`;
}
